@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ 'GENERAL.deleting' | translate }}...
    </mat-label>
  </div>
}
<div class="as-modal-container">
  @if (data?.res?.items?.length) {
    <div class="texts">
      <p class="as-font-18 as-align-center">
        {{ 'PURCHASE.deleteText1' | translate }}
      </p>
      <p class="as-font-16 as-align-center as-font-bold">
        {{ 'PURCHASE.deleteText2' | translate }}
      </p>
    </div>
  } @else {
    <div class="texts">
      <p class="as-font-18 as-align-center">
        {{ 'PURCHASE.deleteText3' | translate }}
      </p>
      <p class="as-font-16 as-align-center as-font-bold">
        {{ 'PURCHASE.deleteText4' | translate }}
      </p>
    </div>
  }


  <div class="container">
    @for (item of productsToDelete; track item) {
      <div class="as-product">
        <img [src]="item.image_url" alt="Imagen de producto" />
        <p class="as-font-14">{{ item.name }}</p>
      </div>
    }
  </div>

  <div class="btn-container">
    <button (click)="closeModal(false)" mat-stroked-button color="accent">
      {{ 'PURCHASE.cancel' | translate }}
    </button>
    <button
      (click)="
        data.type !== 'checkout'
          ? deleteProductsAndContinue()
          : deleteProducts()
      "
      mat-flat-button
      color="accent"
      >
      <mat-label class="as-font-white">{{
        'PURCHASE.accept' | translate
      }}</mat-label>
    </button>
  </div>
</div>
